/*
 * Component.ts
 */
export class Component {
    constructor(id, gameType, roomName, filePaths) {
        this.id = id;
        this.gameType = gameType;
        this.roomName = roomName;
        this.filePaths = filePaths;
        this.textures = [];
    }
    addTexture(value) {
        this.textures.push(value);
    }
    getId() {
        return this.id;
    }
    getFilePaths() {
        return this.filePaths;
    }
    getGameType() {
        return this.gameType;
    }
    getRoomName() {
        return this.roomName;
    }
    hasGameType() {
        return this.gameType != null;
    }
    hasRoomName() {
        return this.roomName != null;
    }
    getKey() {
        let key = this.id;
        if (this.hasGameType()) {
            key += "-" + this.gameType;
        }
        if (this.hasRoomName()) {
            key += "-" + this.roomName;
        }
        return key;
    }
    getTextures() {
        return this.textures;
    }
}
//# sourceMappingURL=Component.js.map